import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tecnicos-modificacioines',
  templateUrl: './tecnicos-modificacioines.component.html',
  styleUrls: ['./tecnicos-modificacioines.component.css']
})
export class TecnicosModificacioinesComponent implements OnInit {

  constructor(private service: UserService, private toast: ToastrService) { }

  tecnicos = [];
  ngOnInit() {
    this.getTecnicos();
  }

  getTecnicos(){
    this.service.getModificacionesTecnicos().subscribe(d=>{
      this.tecnicos = d;
    })
  }

  aceptar(id){
    this.service.aceptarModificacionesTecnicos(id).subscribe(d=>{
      this.getTecnicos();
    })
  }

  rechazar(id){
    this.service.rechazarModificacionesTecnicos(id).subscribe(d=>{
      this.getTecnicos();
    })
  }
}
